const API_PATH = 'https://conmigo-api-dev.intelligential.tech';
const POSTHOG_TOKEN = 'phc_x7JtJTtM97B8JNYjoZRyCu4ZMPGM4eMshEEUWnENHYh3';
const POSTHOG_HOST = 'https://us.i.posthog.com';

const config = {
  api: {
    url: `${API_PATH}/api`,
  },
  telemetry: {
    token: POSTHOG_TOKEN,
    host: POSTHOG_HOST,
  },
};

export default config;
